function compactItemText(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9]/g, '');
}

/** True when the query is blank, or any of the values contains it. */
export function matchesItemQuery(
  query: string,
  ...parts: Array<string | number | null | undefined>
): boolean {
  const needle = query.trim().toLowerCase();
  if (!needle) {
    return true;
  }
  const compactNeedle = compactItemText(needle);
  return parts.some((part) => {
    const text = String(part ?? '').toLowerCase();
    return (
      text.includes(needle) ||
      (!!compactNeedle && compactItemText(text).includes(compactNeedle))
    );
  });
}
